import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'

const app = createApp(App)

function isStandaloneWebApp() {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true
}

async function normalizeLegacyIosStartRoute() {
    const currentRoute = router.currentRoute.value
    if (!isStandaloneWebApp() || currentRoute.path !== '/raiding') {
        return
    }

    const navigationEntry = performance.getEntriesByType('navigation')[0]
    const isColdLaunch = !navigationEntry || navigationEntry.type === 'navigate'

    if (isColdLaunch) {
        await router.replace('/mythic-plus')
    }
}

app.use(store)
app.use(router)

store.dispatch('initialize')

if (process.env.NODE_ENV === 'production') {
    store.dispatch('registerServiceWorker')
} else if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => registration.unregister())
    })
}

router.isReady().then(async () => {
    await normalizeLegacyIosStartRoute()
    app.mount('#app')
})
